export default __webpack_public_path__ + "static/media/location_off_black_24dp.96e69dd3.svg";